package fr.frux.core.common.prefs

import fr.frux.core.common.storage.KeyValueStore
import fr.frux.core.common.storage.browserStorage

internal class WebAppPreferences(
    private val store: KeyValueStore = browserStorage.store,
) : AppPreferences {
    override suspend fun getBoolean(
        key: String,
        default: Boolean,
    ): Boolean = store.getItem(prefixed(key))?.toBooleanStrictOrNull() ?: default

    override suspend fun putBoolean(
        key: String,
        value: Boolean,
    ) {
        store.setItem(prefixed(key), value.toString())
    }

    override suspend fun getString(
        key: String,
        default: String?,
    ): String? = store.getItem(prefixed(key)) ?: default

    override suspend fun putString(
        key: String,
        value: String,
    ) {
        store.setItem(prefixed(key), value)
    }

    override suspend fun remove(key: String) {
        store.removeItem(prefixed(key))
    }

    private fun prefixed(key: String) = "frux_pref_$key"
}

actual fun createAppPreferences(): AppPreferences = WebAppPreferences()
